import React from "react";
import img from "./Images/section3logo.png";
export default function Section3() {
  return (
    <div>
      <section className="third-hightlight-wrapper">
        <div className="container">
          <div className="myWatch">
            <img src={img} />
          </div>

          <div className="price-wrapper">
            <h4>A healthy leap ahead.</h4>
          </div>

          <div className="links-wrapper">
            <ul>
              <li>
                <a href="">Learn more</a>
              </li>
              <li>
                <a href="">Buy</a>
              </li>
            </ul>
          </div>
        </div>
      </section>
    </div>
  );
}
